import { Button } from 'flowbite-react';
import React from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { Img } from 'react-image';

interface Props {
	onClick: () => void;
}

const NoAMCompaniesContainer = ({ onClick }: Props) => {
	return (
		<>
			<div className="flex flex-col items-center justify-center">
				<div className="px-8">
					<div className="flex justify-center">
						<Img
							width="160"
							height="160"
							loading="lazy"
							alt="noApplicationsEmptyState"
							src="/assets/noApplicationsEmptyState.svg"
						/>
					</div>

					<div className="text-center mt-4 text-base font-medium">No active job postings</div>
					<div className="text-center mt-2 text-sm font-normal text-[#28293D] dark:text-[#C7C9D9]">
						Create a new company
					</div>

					<div className="flex justify-center mt-5">
						<Button color="purplePlaced" onClick={onClick}>
							<AiOutlinePlus className="mr-2" />
							Create a company
						</Button>
					</div>
				</div>
			</div>
		</>
	);
};

export default NoAMCompaniesContainer;
